import { Navigate, Route, Router } from "@solidjs/router";
import { Show, type Component } from "solid-js";
import { Dynamic } from "solid-js/web";
import { landingPath, navItems } from "@/apps/registry";
import LoginPage from "@/shared/auth/LoginPage";
import RequireAuth from "@/shared/auth/RequireAuth";
import SetPasswordPage from "@/shared/auth/SetPasswordPage";
import { can, currentUser, signOut } from "@/shared/auth/session";
import { Toaster } from "@/shared/components/Toast";

export default function App() {
  return (
    <>
      <Router>
        <Route path="/login" component={LoginPage} />
        <Route path="/set-password" component={SetPasswordPage} />
        <Route path="/" component={RequireAuth}>
          <Route path="/" component={Landing} />
          {navItems.map((item) => (
            <Route
              path={item.path}
              component={() => <Guarded permission={item.permission} component={item.component} />}
            />
          ))}
          <Route path="*" component={Landing} />
        </Route>
      </Router>
      <Toaster />
    </>
  );
}

/**
 * Where "/" and any unknown path resolve to, which depends on the user: the
 * first page their role lets them open.
 */
function Landing() {
  return (
    <Show when={landingPath()} fallback={<NoAccess />}>
      {(path) => <Navigate href={path()} />}
    </Show>
  );
}

/**
 * Keeps a page out of the hands of somebody whose role does not include it,
 * whether they followed a stale link or typed the path. The API behind the page
 * refuses them regardless; this is what stops them seeing an empty screen full
 * of failed requests instead of being told.
 */
function Guarded(props: { permission: string; component: Component }) {
  return (
    <Show when={can(props.permission)} fallback={<Navigate href="/" />}>
      <Dynamic component={props.component} />
    </Show>
  );
}

/** A signed-in account whose role grants nothing at all. */
function NoAccess() {
  return (
    <div class="view active">
      <div class="view-header">
        <h1>No access yet</h1>
      </div>
      <p style={{ color: "var(--text-muted)", "max-width": "440px" }}>
        {currentUser()?.firstName ?? "You"}, your account does not have permission to open
        anything yet. Ask an administrator to give your account a role.
      </p>
      <button type="button" class="btn btn-ghost" style={{ "margin-top": "16px" }} onClick={signOut}>
        Sign out
      </button>
    </div>
  );
}
